export default "__VITE_ASSET__BY5BQ2E5__"